import { TAGS, api } from "../../api"
import { ISpecialDeal } from "./types"

const basePath = "/special-deals"

export const specialDealsApi = api.enhanceEndpoints({
  addTagTypes: [TAGS.SPECIAL_DEALS]
})

export const specialDealsEndpoints = specialDealsApi.injectEndpoints({
  endpoints: (builder) => ({
    getActiveSpecialDeals: builder.query<ISpecialDeal, void>({
      query: () => {
        return {
          url: `${basePath}/active`,
          method: "GET"
        }
      },
      providesTags: () => [{ type: TAGS.SPECIAL_DEALS, id: `ACTIVE` }]
    })
  })
})

export const { useGetActiveSpecialDealsQuery } = specialDealsEndpoints
